import { HTTP_RESPONSE_STATUS } from 'common/constants/httpMethodsConstants'

import type {
  AttachAppointmentIssueBody,
  MedicalIssue,
  MedicalIssueType,
} from './medicalIssues.types'

type IssuesResponse = { data?: MedicalIssue[] } | MedicalIssue[] | null | undefined
type IssueResponse = { data?: MedicalIssue } | MedicalIssue | null | undefined

export const transformMedicalIssuesResponse = (response: IssuesResponse): MedicalIssue[] => {
  if (!response) return []
  if (Array.isArray(response)) return response
  return response.data ?? []
}

export const transformMedicalIssueResponse = (response: IssueResponse): MedicalIssue | null => {
  if (!response) return null
  if ('data' in response) return response.data ?? null
  return response as MedicalIssue
}

const ISSUE_TYPE_PREFIX: Record<MedicalIssueType, string> = {
  medical_problem: 'Medical',
  cosmetic: 'Cosmetic',
}

export const getIssueOptionLabel = (issue: MedicalIssue): string =>
  `${ISSUE_TYPE_PREFIX[issue.type] ?? issue.type_label}: ${issue.title}`

// The shared base query flattens error bodies to string[] (fetchBaseQuery.ts extractErrorData).
export const getNotFoundMessage = (error: unknown): string | null => {
  const apiError = error as { status?: number; data?: unknown } | undefined
  if (!apiError || apiError.status !== HTTP_RESPONSE_STATUS.NOT_FOUND) return null
  if (Array.isArray(apiError.data) && typeof apiError.data[0] === 'string') {
    return apiError.data[0]
  }
  return 'Not found'
}

// First server-sent message from a flattened error body, or the fallback.
export const getIssueErrorMessage = (error: unknown, fallback: string): string => {
  const apiError = error as { data?: unknown } | undefined
  if (Array.isArray(apiError?.data) && typeof apiError.data[0] === 'string' && apiError.data[0]) {
    return apiError.data[0]
  }
  return fallback
}

export const buildAttachIssueBody = (input: {
  issueId?: number
  title?: string
  type?: MedicalIssueType
}): AttachAppointmentIssueBody => {
  if (input.issueId) return { issue_id: input.issueId }
  return {
    title: (input.title ?? '').trim(),
    ...(input.type ? { type: input.type } : {}),
  }
}
